import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var Item = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment item on ListHome {\n    items {\n      id\n      image {\n        src\n        alt\n      }\n      link {\n        text\n        href\n      }\n    }\n  }\n"])));
export default Item;